// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__43Pb3","large":"styles_large__2h749"};